import { cloneDeep } from 'lodash';

import auroraLandingPageMembershipTabData from '../_data/auroraLandingPageMembershipTabData';
import trustedAdvisorMembershipTabDataOverrides from '../_data/trustedAdvisorMembershipTabDataOverrides';

const getLandingPageMembershipTabData = (isTrustedAdvisorEnabled: boolean) => {
  if (isTrustedAdvisorEnabled) {
    return cloneDeep(auroraLandingPageMembershipTabData).map((tab) => ({
      ...tab,
      tabPanel: {
        ...tab.tabPanel,
        ...trustedAdvisorMembershipTabDataOverrides[tab.id]?.tabPanel,
      },
    }));
  }
  return auroraLandingPageMembershipTabData;
};

export default getLandingPageMembershipTabData;
